<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="white" small fab v-bind="attrs" v-on="on" height="30px" width="30px">
        <v-icon color="#00aff2">mdi-eye</v-icon>
      </v-btn>
    </template>
    <v-card>
    <div class="padding-card">
        <p class="title-modal">Información del pago realizado</p>
      <v-form ref="formSpend" v-model="validFormSpend" lazy-validation>
        <v-text-field label="Concepto de pago" :rules="rules.lonxl" v-model="egreso.concept"></v-text-field> 
        <v-row>  
          <v-col>   
            <v-autocomplete
            label="Status"
            v-model="egreso.status"
            :items="['Presupuesto', 'Programado', 'Procesado']"
          ></v-autocomplete>
          </v-col>
          <v-col>   
            <v-autocomplete
            label="Tipo de Egreso"
            v-model="egreso.tipo_egreso"
            :items="['Preventivo', 'Correctivo', 'Extraordinario', 'Equipamiento', 'Servicio']"
          ></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              item-text="name"
              item-value="id"
              label="Tipo de pago"
              v-model="egreso.paymentTypeId"
              :items="paymentItems"
            ></v-autocomplete>  
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field label="Núm cheque" :rules="rules.lonlg" v-model="egreso.referencia"></v-text-field>   
          </v-col>
          <v-col>
              <label for="date"
              ><DatePicker           
                label="Fecha Gasto"
                name="date"
                :initialDate="egreso.fecha_gasto"
                @change="egreso.fecha_gasto = $event"
            /></label>
          </v-col>
        </v-row> 
        <v-text-field label="Proveedor"  :rules="rules.lonxl" v-model="egreso.supplier"></v-text-field>
        <v-textarea label="Descripción" :rules="rules.lonxxl" filled outlined v-model="egreso.description"></v-textarea>
        <v-text-field prefix="$" suffix="MXN" label="Importe pagado" v-model="egreso.amount"></v-text-field>
      </v-form>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
         <v-btn color="red darken-1" text @click="deletespend"> Eliminar </v-btn>
        <v-btn color="blue darken-1" text @click="updateSpend"> Actualizar </v-btn>       
        <v-btn color="blue darken-1" text @click="dialog = false; $emit('on-close')"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import adminSuppliersService from '@/services/admin/supplierPayments';
import DatePicker from '@/components/DatePicker.vue';

export default {
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { DatePicker },
  data: () => ({
    dialog: false,
    validFormSpend: null,
    paymentItems: [],
    egreso: {},
    rules: {
          required: (value) => !!value || 'Required.',         
          lonsm: [ (v) => !v || v.length <= 50 || 'Nombre debe ser menor a 50 caracteres' ],
          lonmd: [ (v) => !v || v.length <= 60 || 'Nombre debe ser menor a 60 caracteres' ],
          lonlg: [ (v) => !v || v.length <= 100 || 'Nombre debe ser menor a 100 caracteres' ],
          lonxl: [ (v) => !v || v.length <= 255 || 'Nombre debe ser menor a 255 caracteres' ],
          lonxxl: [ (v) => !v || v.length <= 1024 || 'Nombre debe ser menor a 1024 caracteres' ],
          },
  }),
  created(){
    this.egreso = JSON.parse(JSON.stringify(this.post));
  },
  mounted () {
    this.paymentTypes();
  },
  methods: {
    paymentTypes() {
      adminSuppliersService.paymentTypes().then((response) => {
        this.paymentItems = response.data;
      });
    },
    updateSpend() {
      if (this.$refs.formSpend.validate()) {
      const data = {
        concept: this.egreso.concept,
        description: this.egreso.description,
        paymentTypeId: this.egreso.paymentTypeId,
        tipo_egreso: this.egreso.tipo_egreso,
        fecha_gasto: this.egreso.fecha_gasto,
        referencia: this.egreso.referencia,
        status: this.egreso.status,
        supplier: this.egreso.supplier,
        amount: this.egreso.amount,
      };
      adminSuppliersService
          .update(this.post.id, data)
          .then(() => {
            this.$swal('Egreso actualizado', 'El egreso se ha actualizado con éxito', 'success');
            this.$emit('on-update');
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al actualizar egreso', error.response.data.message, 'warning');
            }
          });
      }
    },
    deletespend() {
      adminSuppliersService
          .eliminar(this.post.id)
          .then(() => {
            this.$swal('Egreso eliminado', 'El egreso se eliminó éxito', 'success');
            this.$emit('on-update');
          })
          .catch((error) => {
            if (error.response && error.response.status === 400) {
              this.$swal('Error al eliminar egreso', error.response.data.message, 'warning');
            }
          });
    }
  },
  watch: {
    post: {
      handler(newVal) {
        if (newVal) {
          this.egreso = JSON.parse(JSON.stringify(newVal));
        }
      },
      immediate: true, // para que se ejecute también al cargar
      deep: true
    },   
  }
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>